// Enum for activity types that come from the API

export default {
    // Running
    Running: 'running',
    IndoorRunning: 'indoor_running',
    ObstacleRun: 'obstacle_run',
    StreetRunning: 'street_running',
    TrackRunning: 'track_running',
    TrailRunning: 'trail_running',
    TreadmillRunning: 'treadmill_running',
    UltraRun: 'ultra_run',
    VirtualRun: 'virtual_run',

    // Cycling
    Cycling: 'cycling',
    Bmx: 'bmx',
    Cyclocross: 'cyclocross',
    DownhillBiking: 'downhill_biking',
    EBikeFitness: 'e_bike_fitness',
    EBikeMountain: 'e_bike_mountain',
    GravelCycling: 'gravel_cycling',
    HandCycling: 'hand_cycling',
    IndoorCycling: 'indoor_cycling',
    IndoorHandCycling: 'indoor_hand_cycling',
    MountainBiking: 'mountain_biking',
    RecumbentCycling: 'recumbent_cycling',
    RoadBiking: 'road_biking',
    TrackCycling: 'track_cycling',
    VirtualRide: 'virtual_ride',
    EnduroMtb: 'enduro_mtb',
    EEnduroMtb: 'e_enduro_mtb',

    // Gym & Fitness Equipment
    FitnessEquip: 'fitness_equipment',
    Bouldering: 'bouldering',
    Cardio: 'indoor_cardio',
    Dance: 'dance',
    Elliptical: 'elliptical',
    Hiit: 'hiit',
    IndoorClimbing: 'indoor_climbing',
    IndoorRowing: 'indoor_rowing',
    OnShoreGrinding: 'onshore_grinding',
    OnShoreGrindingV2: 'onshore_grinding_v2',
    JumpRope: 'jump_rope',
    Pilates: 'pilates',
    StrengthTraining: 'strength_training',
    Yoga: 'yoga',
    Mobility: 'mobility',

    // Swimming
    Swimming: 'swimming',
    LapSwimming: 'lap_swimming',
    OpenWaterSwimming: 'open_water_swimming',

    // Walking
    Walking: 'walking',
    CasualWalking: 'casual_walking',
    SpeedWalking: 'speed_walking',

    // Hiking
    Hiking: 'hiking',
    Rucking: 'rucking',

    // Diving
    Diving: 'diving',
    ApneaDiving: 'apnea_diving',
    PoolApnea: 'pool_apnea',
    ApneaHunting: 'apnea_hunting',
    CcrDiving: 'ccr_diving',
    GaugeDiving: 'gauge_diving',
    MultiGasDiving: 'multi_gas_diving',
    SingleGasDiving: 'single_gas_diving',

    // Winter Sports
    WinterSports: 'winter_sports',
    BackcountrySki: 'backcountry_skiing_snowboarding_ws',
    BackcountrySkiing: 'backcountry_skiing',
    BackcountrySnowboarding: 'backcountry_snowboarding',
    CrossCountrySkiing: 'cross_country_skiing_ws',
    ResortSkiing: 'resort_skiing',
    ResortSkiSnowboard: 'resort_skiing_snowboarding_ws',
    ResortSnowboarding: 'resort_snowboarding',
    SkateSkiing: 'skate_skiing_ws',
    Skating: 'skating_ws',
    Snowmobiling: 'snowmobiling_ws',
    SnowShoeing: 'snow_shoe_ws',

    // Water Sports
    WaterSports: 'water_sports',
    Boating: 'boating_v2',
    Fishing: 'fishing_v2',
    Kayaking: 'kayaking_v2',
    Kiteboarding: 'kiteboarding_v2',
    OffShoreGrinding: 'offshore_grinding',
    OffShoreGrindingV2: 'offshore_grinding_v2',
    Paddling: 'paddling_v2', // aka Canoeing
    Rowing: 'rowing_v2',
    Sailing: 'sailing_v2',
    Snorkeling: 'snorkeling',
    StandUpPaddleboarding: 'stand_up_paddleboarding_v2',
    Surfing: 'surfing',
    SurfingV2: 'surfing_v2',
    Wakeboarding: 'wakeboarding',
    WakeboardingV2: 'wakeboarding_v2', // a.k.a. wakesports
    Wakesurfing: 'wakesurfing', // a.k.a. wakesports
    Waterskiing: 'waterskiing', // a.k.a. wakesports
    Watertubing: 'water_tubing', // a.k.a. wakesports
    WhitewaterRafting: 'whitewater_rafting_v2',
    Windsurfing: 'windsurfing',
    WindsurfingV2: 'windsurfing_v2',

    // Team Sports
    TeamSports: 'team_sports',
    AmericanFootball: 'american_football',
    Baseball: 'baseball',
    Basketball: 'basketball',
    Cricket: 'cricket',
    FieldHockey: 'field_hockey',
    IceHockey: 'ice_hockey',
    Lacrosse: 'lacrosse',
    Rugby: 'rugby',
    Soccer: 'soccer',
    Softball: 'softball',
    UltimateDisc: 'ultimate_disc',
    Volleyball: 'volleyball',

    // Racket Sports
    RacketSports: 'racket_sports',
    Badminton: 'badminton',
    Padel: 'paddelball',
    Pickleball: 'pickleball',
    PlatformTennis: 'platform_tennis',
    Racquetball: 'racquetball',
    Squash: 'squash',
    TableTennis: 'table_tennis',
    TennisV2: 'tennis_v2',

    // Parasports
    Parasports: 'para_sports',
    WheelchairPushRun: 'wheelchair_push_run',
    WheelchairPushWalk: 'wheelchair_push_walk',

    // Multisport
    MultiSport: 'multi_sport',
    BikeToRunTransition: 'bikeToRunTransition',
    BikeToRunTransitionV2: 'bikeToRunTransition_v2',
    RunToBikeTransition: 'runToBikeTransition_v2',
    RunToBikeTransitionV2: 'runToBikeTransition',
    SwimToBikeTransition: 'swimToBikeTransition',
    SwimToBikeTransitionV2: 'swimToBikeTransition_v2',
    Transition: 'transition',
    TransitionV2: 'transition_v2',

    // Other
    Other: 'other',
    Archery: 'archery',
    Atv: 'atv',
    AtvV2: 'atv_v2',
    AutoRacing: 'auto_racing',
    Boxing: 'boxing',
    Breathwork: 'breathwork',
    DiscGolf: 'disc_golf',
    Driving: 'driving_general',
    Esport: 'e_sport', // renamed to Gaming
    FloorClimbing: 'floor_climbing',
    Flying: 'flying',
    Golf: 'golf',
    HangGliding: 'hang_gliding',
    HorsebackRiding: 'horseback_riding',
    Hunting: 'hunting',
    HuntingFishing: 'hunting_fishing',
    InlineSkating: 'inline_skating',
    Meditation: 'meditation',
    MixedMartialArts: 'mixed_martial_arts',
    Motocross: 'motocross',
    MotocrossV2: 'motocross_v2',
    Motorcycling: 'motorcycling',
    MotorcyclingV2: 'motorcycling_v2',
    Mountaineering: 'mountaineering',
    Overland: 'overland',
    RcDrone: 'rc_drone',
    RockClimbing: 'rock_climbing',
    SkyDiving: 'sky_diving',
    Shooting: 'shooting',
    StairClimbing: 'stair_climbing',
    Stopwatch: 'stop_watch',
    Uncategorized: 'uncategorized',
    WingsuitFlying: 'wingsuit_flying',

    // Safety
    Safety: 'safety',
    Assistance: 'assistance',
    Emergency: 'emergency',
    IncidentDetected: 'incident_detected'
};
